import React from 'react';
import { Link } from '@mui/material';
import { useHistory } from 'react-router-dom';

interface ICustomLink {
    children: any;
    link: any;
    disabled?: any;
    shouldUseHistory?: boolean;
    align?: 'right' | 'left' | 'inherit' | 'center' | 'justify'
}
export default function CustomLink({
    children,
    link,
    disabled,
    shouldUseHistory,
    align = 'left'
}: ICustomLink): JSX.Element {

    const history = useHistory();

    const openInNewTab = (link: any) => {
        window.open(link, '_blank', 'noopener,noreferrer');
    };

    const mouseDownHandler = (event: any) => {
        if(event.button === 1) {
            openInNewTab(`#${link}`);
        }
    };

    return (
        <>
            {!shouldUseHistory &&
                <Link align={align} width="100%" underline="none" color="secondary" href={link} >
                    {children}
                </Link>
            }
            {!!shouldUseHistory &&
                <Link component={!disabled ? 'button' : 'span'}
                    underline="none" color="secondary" width="100%" align={align}
                    onClick={() => !disabled ? history.push(link) : {}}
                    onContextMenu={() => openInNewTab(`#${link}`)}
                    onMouseDown={mouseDownHandler}>
                    {children}
                </Link>
            }
        </>
    );
}